import { HTML_ELEMENTS } from "@js/constants/html-constants.es6.js";

export default class AnimationUtils {
  /**
   * Scroll to the first instance of the element specified by the selector,
   * taking into account the header's current height.
   *
   * @param {string} $element the jQuery object for the element of interest
   * @param {string} $speed the number of milliseconds the animation should take
   */
  static scrollToElementWithJQuery({ $element, speed = 1000 }) {
    if (!$element.length) {
      throw new Error('No element found.');
    }

    const elementTopOffset = $element.offset().top;

    const $header = jQuery(HTML_ELEMENTS.HEADER);
    const headerOuterHeight = $header.outerHeight();

    const scrollTop = elementTopOffset - headerOuterHeight;

    jQuery(`${HTML_ELEMENTS.HTML}, ${HTML_ELEMENTS.BODY}`).animate(
      { scrollTop },
      speed,
    );
  }

  /**
   * Scroll to the first instance of the element specified by the selector,
   * taking into account the header's current height.
   *
   * @param {string} element the DOM element of interest
   */
  static scrollToElement(element) {
    if (!element) {
      throw new Error('No element found.');
    }

    const elementTopOffset = element.getBoundingClientRect().top + window.scrollY;

    const header = document.querySelector(HTML_ELEMENTS.HEADER);
    const headerOuterHeight = header.offsetHeight;

    const scrollTop = elementTopOffset - headerOuterHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  }
}
